import axios from 'axios';
import { hasAuthAccessParams } from '../types/guards';
import { processResponse, processError, privateRequestParams } from '../utils';
export default class HeroPillsAPI {
    static getDayToDayPills(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/last-d2d-config/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static setDayToDayPills(accessParams, config) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/set-d2d-config/', {
            pills: config.pills,
            timezone_offset: config.timezone_offset,
            parental_lock: config.parental_lock
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static setRefillState(accessParams, slot, refill_prompt) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/set-refill-prompt/', { slot: slot, refill_prompt: refill_prompt }, privateRequestParams(accessParams))
            .then(function (refillResponse) {
            const rr = processResponse(refillResponse);
            if (rr.statusCode === 0) {
                return axios
                    .get(accessParams.API_ENDPOINT + 'frontend/last-d2d-config/', privateRequestParams(accessParams))
                    .then(function (response) {
                    return processResponse(response);
                })
                    .catch(function (error) {
                    return processError(error);
                });
            }
            return rr;
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPillsData(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/device-config-get/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPillsUnconfirmedData(accessParams, old_session_id, session_id, timezone_offset) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-reuse/', {
            old_session_id,
            session_id,
            timezone_offset
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static addPillData(accessParams, session_id, pill) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-add-pill/', { session_id, pill }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static addMultiPillData(accessParams, session_id, pills, current = 0) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-add-pill/', { session_id, pill: pills[current] }, privateRequestParams(accessParams))
            .then(function (response) {
            const result = processResponse(response);
            if (current === pills.length - 1) {
                // Return last call as result since it will return latest pill data
                return result;
            }
            else if (result.statusCode === 0) {
                return HeroPillsAPI.addMultiPillData(accessParams, session_id, pills, ++current);
            }
            return result;
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static movePillData(accessParams, session_id, slot, pill) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-remove-pill/', { session_id, slot }, privateRequestParams(accessParams))
            .then(function (response) {
            const result = processResponse(response);
            if (result.statusCode === 0) {
                return axios
                    .post(accessParams.API_ENDPOINT + 'frontend/user-config-add-pill/', { session_id, pill }, privateRequestParams(accessParams))
                    .then(function (response) {
                    return processResponse(response);
                })
                    .catch(function (error) {
                    return processError(error);
                });
            }
            return result;
        })
            .catch((error) => {
            return processError(error);
        });
    }
    static removePillData(accessParams, session_id, slot) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-remove-pill/', { session_id, slot }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static saveConfig(accessParams, session_id) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-activate/', { session_id }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getFreSlots(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/get-taken-slots/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    // eslint-disable-next-line sonarjs/no-identical-functions
    static getPinLock(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/device-config-get/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static setPinLock(accessParams, session_id, parental_lock, timezone_offset) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-set-parental-lock/', { session_id, parental_lock, timezone_offset }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static removePinLock(accessParams, session_id) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-config-set-parental-lock/', { session_id, parental_lock: null }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getDrugInformation(accessParams, gpi) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'drugs/leaflet', { gpi }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getAddedPillInteractions(accessParams, new_pill, existing_pills) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/added-drug-interactions/', {
            new_pill,
            existing_pills
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPillProperties(accessParams, pill_name) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT +
            `frontend/pill-properties-read?name=${encodeURIComponent(pill_name)}`, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static updatePillProperties(accessParams, name, data) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .patch(accessParams.API_ENDPOINT + 'frontend/pill-properties-edit', Object.assign({ name }, data), privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static addPillProperties(accessParams, name, img, order = 1) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/pill-images-edit/', {
            name,
            img_base64: img,
            order
        }, privateRequestParams(accessParams, { timeout: 30000 }))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static deletePillProperties(accessParams, id) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .delete(accessParams.API_ENDPOINT + 'frontend/pill-images-edit/', privateRequestParams(accessParams, { data: { id } }))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getDrugStubs(accessParams, search_string) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/drug-db-get-stubs', { search_string }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(Object.assign({}, response, { data: Array.prototype.concat(...response.data) }));
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map